// bday-switcher Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Content for different bottle types
  const bottleContent = {
    standard: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      title: "1 JuiceBox™ Trinkflasche",
      originalPrice: "9,90€",
      discountedPrice: "0,00€",
      headlineText: "Heute GRATIS im Set:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Trinkflasche",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      accordionTitle: "Trinkflasche",
      accordionBadge: "Gratis",
      
      // visibility settings
      showBottleBlock: false // Hide the bottle block for standard option
    },
    premium: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/jb-bootle-1.5l.webp?v=1741593807",
      title: "1 JuiceBox™ Glastrinkflasche 1,5 L",
      originalPrice: "29,90€",
      discountedPrice: "9,90€",
      headlineText: "Deine Set-Vorteile:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Glastrinkflasche 1,5 L",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/jb-bootle-1.5l.webp?v=1741593807",
      accordionTitle: "Glastrinkflasche 1,5 L",
      accordionBadge: "spare €20,00",
      
      // visibility settings
      showBottleBlock: true // Show the bottle block for premium option
    }
  };
  
  // Function to update all bottle-related content
  function updateBottleContent(bottleType) {
    const content = bottleContent[bottleType];
    
    // Get all elements by ID
    const elements = {
      // bundle-includes elements
      image: document.getElementById('bottle-image-display'),
      heading: document.getElementById('bottle-heading'),
      title: document.getElementById('bottle-title'),
      originalPrice: document.getElementById('bottle-original-price'),
      discountedPrice: document.getElementById('bottle-discounted-price'),
      listItem: document.getElementById('bottle-list-item'),
      
      // accordion elements
      accordionImage: document.getElementById('accordion-bottle-image'),
      accordionTitle: document.getElementById('accordion-bottle-title'),
      accordionBadge: document.getElementById('accordion-bottle-badge')
    };
    
    // 1. Hide/show the bottle container in the bundle includes section
    // Find the parent element of the bottle image
    if (elements.image) {
      // Go up to the .free_gift_block container
      const bottleContainer = findParentWithClass(elements.image, 'free_gift_block');
      if (bottleContainer) {
        bottleContainer.style.display = content.showBottleBlock ? 'block' : 'none';
      }
    }
    
    // 2. Hide/show the list item directly by ID
    if (elements.listItem) {
      elements.listItem.style.display = content.showBottleBlock ? 'flex' : 'none';
    }
    
    // 3. Hide/show the accordion card 
    if (elements.accordionImage) {
      // Go up to the .jb-small-card container
      const accordionBottleCard = findParentWithClass(elements.accordionImage, 'jb-small-card');
      if (accordionBottleCard) {
        accordionBottleCard.style.display = content.showBottleBlock ? 'block' : 'none';
      }
    }
    
    // 4. Update content for visible elements
    if (content.showBottleBlock) {
      // Only update content if elements are visible
      if (elements.image) elements.image.src = content.image;
      if (elements.heading) elements.heading.textContent = content.headlineText;
      if (elements.title) elements.title.textContent = content.title;
      if (elements.originalPrice) elements.originalPrice.textContent = content.originalPrice;
      if (elements.discountedPrice) elements.discountedPrice.textContent = content.discountedPrice;
      if (elements.listItem) elements.listItem.innerHTML = content.listItemText;
      
      // Update accordion content
      if (elements.accordionImage) elements.accordionImage.src = content.accordionImage;
      if (elements.accordionTitle) elements.accordionTitle.textContent = content.accordionTitle;
      if (elements.accordionBadge) elements.accordionBadge.textContent = content.accordionBadge;
    }
    // Always keep the straw badge showing "GRATIS" regardless of bottle selection
    const strawBadge = document.querySelector('.product-image-container img[src*="jb-straws"] + .bundle_tooltip');
    if (strawBadge) {
      strawBadge.textContent = "GRATIS";
      strawBadge.classList.add('purple-color'); // Ensure it has the purple background
    }
  }
  
  // Helper function to find parent element with a specific class
  function findParentWithClass(element, className) {
    let currentElement = element;
    while (currentElement !== null) {
      if (currentElement.classList && currentElement.classList.contains(className)) {
        return currentElement;
      }
      currentElement = currentElement.parentElement;
    }
    return null;
  }
  
  // Observer to watch for changes to the bottle selection
  function initBottleSwitcher() {
    const bottleCards = document.querySelectorAll('.JB-bottle-card');
    if (bottleCards.length === 0) return false;
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const targetElement = mutation.target;
          if (targetElement.classList.contains('active')) {
            const bottleTypeValue = targetElement.querySelector('input[type="text"]').value;
            updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
          }
        }
      });
    });
    
    // Start observing the bottle selection cards
    bottleCards.forEach(card => {
      observer.observe(card, { attributes: true });
    });
    
    // Set initial content based on which card is active
    let initialSet = false;
    bottleCards.forEach(card => {
      if (card.classList.contains('active')) {
        const bottleTypeValue = card.querySelector('input[type="text"]').value;
        updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
        initialSet = true;
      }
    });
    
    // If no card is active, default to standard
    if (!initialSet && bottleCards.length > 0) {
      updateBottleContent('standard');
    }
    
    return true;
  }
  
  // Try to initialize, retry with a delay if elements aren't available yet
  if (!initBottleSwitcher()) {
    const checkInterval = setInterval(function() {
      if (initBottleSwitcher()) {
        clearInterval(checkInterval);
      }
    }, 500);
    
    // Safety timeout to prevent infinite checking
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 10000);
  }
});